import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { lineHeightTight } from "../../../../eden-style-constants";
import { ChevronDown as ChevDown } from "../../../../eden-icons";
const base = css(["line-height:", ";"], lineHeightTight);
const Chevron = styled(ChevDown).withConfig({
  componentId: "sc-cvfmde-0"
})(["", ";details[open] > summary &&{transform:rotate(180deg);}"], base);
const HandleOuter = styled.summary.withConfig({
  componentId: "sc-cvfmde-1"
})(["display:block;cursor:pointer;width:100%;list-style:none;&::-webkit-details-marker{display:none;}"]);
const FlexWrapper = styled.div.withConfig({
  componentId: "sc-cvfmde-2"
})(["display:flex;justify-content:space-between;align-items:center;"]);

const Summary = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(HandleOuter, props, /*#__PURE__*/React.createElement(FlexWrapper, null, children, /*#__PURE__*/React.createElement(Chevron, {
    size: "1.5rem"
  })));
};

Summary.propTypes = {
  /** Contents rendered inside the Summary */
  children: PropTypes.node.isRequired
};
export default Summary;